import { AccessRightsType } from './servicesTypes/configTypes'
import { authUser } from '../constants/common'

export type AuthType = (typeof authUser)[keyof typeof authUser]
export type AccessRights = Nullable<AccessRightsType>
export enum TokenType {
  ACCESS = 'access',
  REFRESH = 'refresh',
}
